import TiptapBaseController from './tiptap_base';
import SerializeToInput from '@/js/util/tiptap/serializers/serialize_to_input';
import Config from '@/js/util/tiptap/config/builder';

export default class extends TiptapBaseController {
  static targets = ['page', 'content'];
  static values = { variant: String, placeholder: String };

  connect() {
    super.connect();
  }

  get _element() {
    return this.pageTarget;
  }

  get _serializer() {
    return new SerializeToInput(this.contentTarget);
  }

  get _extensions() {
    return Config.for(this.variantValue, { placeholder: this.placeholderValue }).extensions;
  }

  get _commandHandlers() {
    return Config.for(this.variantValue).handlers;
  }
}
